import React from 'react';
import { Check } from 'lucide-react';
import { content } from '../data/mock';
import './WhySection.css';

const WhySection = ({ language }) => {
  const t = content[language].why;

  return (
    <section>
      <div className="container split">
        <div className="panel">
          <h2 style={{ marginTop: 0 }}>{t.title}</h2>
          <div className="list">
            {t.items.map((item, index) => (
              <div key={index} className="item">
                <span className="check">
                  <Check size={16} strokeWidth={3} />
                </span>
                <span>{item}</span>
              </div>
            ))}
          </div>
        </div>
        <div
          className="panel"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <img
            src="/assets/logo-dark.png"
            alt="Brilliant Touch logo dark version"
            style={{
              maxHeight: '360px',
              objectFit: 'contain',
              background: '#000',
              borderRadius: '24px',
              padding: '1rem',
              width: '100%'
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default WhySection;
